var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.src
    ? _c("div", { staticClass: "wf-article-media-item" }, [
        _c(
          "div",
          { staticClass: "wf-article-media-item-image" },
          [
            _vm.src.split(".").pop() == ".mp4"
              ? _c("pc-video-tag", {
                  attrs: { src: _vm.src, type: "video/mp4" }
                })
              : _c("pc-image-tag", { attrs: { src: _vm.src, alt: _vm.alt } })
          ],
          1
        ),
        _vm._v(" "),
        _vm.caption
          ? _c("div", { staticClass: "wf-article-media-item-caption" }, [
              _vm._v("\n    " + _vm._s(_vm.caption) + "\n  ")
            ])
          : _vm._e()
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }